<template>
  <add-edit-folder></add-edit-folder>
</template>

<script>
import AddEditFolder from "@/layouts/components/masters/folders/addedit-folder.vue";
export default {
  components: {
    AddEditFolder,
  },
};
</script>
